import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[i2a-container]',
})
export class ContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}